/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllOnboardingServiceAccess } from '../fn/onboarding/get-all-onboarding-service-access';
import { GetAllOnboardingServiceAccess$Params } from '../fn/onboarding/get-all-onboarding-service-access';
import { getAllOnboardingSubscriptionAccess } from '../fn/onboarding/get-all-onboarding-subscription-access';
import { GetAllOnboardingSubscriptionAccess$Params } from '../fn/onboarding/get-all-onboarding-subscription-access';
import { getAllServiceOnboardedUsers } from '../fn/onboarding/get-all-service-onboarded-users';
import { GetAllServiceOnboardedUsers$Params } from '../fn/onboarding/get-all-service-onboarded-users';
import { getAllSubscriptionOnboardedUsers } from '../fn/onboarding/get-all-subscription-onboarded-users';
import { GetAllSubscriptionOnboardedUsers$Params } from '../fn/onboarding/get-all-subscription-onboarded-users';
import { getUserOnboardingGrantHistory } from '../fn/onboarding/get-user-onboarding-grant-history';
import { GetUserOnboardingGrantHistory$Params } from '../fn/onboarding/get-user-onboarding-grant-history';
import { grantServiceAccessThroughOnboarding } from '../fn/onboarding/grant-service-access-through-onboarding';
import { GrantServiceAccessThroughOnboarding$Params } from '../fn/onboarding/grant-service-access-through-onboarding';
import { grantSubscriptionAccessThroughOnboarding } from '../fn/onboarding/grant-subscription-access-through-onboarding';
import { GrantSubscriptionAccessThroughOnboarding$Params } from '../fn/onboarding/grant-subscription-access-through-onboarding';
import { inviteContactToOnboard } from '../fn/onboarding/invite-contact-to-onboard';
import { InviteContactToOnboard$Params } from '../fn/onboarding/invite-contact-to-onboard';
import { OnboardedUser } from '../models/onboarded-user';
import { OnboardingAccess } from '../models/onboarding-access';
import { OnboardingHistory } from '../models/onboarding-history';
import { restoreOnboardingServiceAccess } from '../fn/onboarding/restore-onboarding-service-access';
import { RestoreOnboardingServiceAccess$Params } from '../fn/onboarding/restore-onboarding-service-access';
import { restoreOnboardingSubscriptionAccess } from '../fn/onboarding/restore-onboarding-subscription-access';
import { RestoreOnboardingSubscriptionAccess$Params } from '../fn/onboarding/restore-onboarding-subscription-access';
import { revokeOnboardingServiceAccess } from '../fn/onboarding/revoke-onboarding-service-access';
import { RevokeOnboardingServiceAccess$Params } from '../fn/onboarding/revoke-onboarding-service-access';
import { revokeOnboardingSubscriptionAccess } from '../fn/onboarding/revoke-onboarding-subscription-access';
import { RevokeOnboardingSubscriptionAccess$Params } from '../fn/onboarding/revoke-onboarding-subscription-access';


/**
 * All about the onboarding feature
 */
@Injectable({ providedIn: 'root' })
export class OnboardingService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `inviteContactToOnboard()` */
  static readonly InviteContactToOnboardPath = '/custom/onboarding/{contactUid}/onboard';

  /**
   * Trigger an email invitation to onboard a subscription contact onto a subscription number.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inviteContactToOnboard()` instead.
   *
   * This method doesn't expect any request body.
   */
  inviteContactToOnboard$Response(params: InviteContactToOnboard$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return inviteContactToOnboard(this.http, this.rootUrl, params, context);
  }

  /**
   * Trigger an email invitation to onboard a subscription contact onto a subscription number.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inviteContactToOnboard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inviteContactToOnboard(params: InviteContactToOnboard$Params, context?: HttpContext): Observable<void> {
    return this.inviteContactToOnboard$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllSubscriptionOnboardedUsers()` */
  static readonly GetAllSubscriptionOnboardedUsersPath = '/custom/onboarding/subscription/{subscriptionUid}/users';

  /**
   * Get all users who have access to this subscription through onboarding.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSubscriptionOnboardedUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptionOnboardedUsers$Response(params: GetAllSubscriptionOnboardedUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardedUser>>> {
    return getAllSubscriptionOnboardedUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all users who have access to this subscription through onboarding.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSubscriptionOnboardedUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptionOnboardedUsers(params: GetAllSubscriptionOnboardedUsers$Params, context?: HttpContext): Observable<Array<OnboardedUser>> {
    return this.getAllSubscriptionOnboardedUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OnboardedUser>>): Array<OnboardedUser> => r.body)
    );
  }

  /** Path part for operation `getUserOnboardingGrantHistory()` */
  static readonly GetUserOnboardingGrantHistoryPath = '/custom/onboarding/user/{userUid}/history';

  /**
   * Get user onboarding grant history.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserOnboardingGrantHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOnboardingGrantHistory$Response(params: GetUserOnboardingGrantHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardingHistory>>> {
    return getUserOnboardingGrantHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Get user onboarding grant history.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserOnboardingGrantHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOnboardingGrantHistory(params: GetUserOnboardingGrantHistory$Params, context?: HttpContext): Observable<Array<OnboardingHistory>> {
    return this.getUserOnboardingGrantHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OnboardingHistory>>): Array<OnboardingHistory> => r.body)
    );
  }

  /** Path part for operation `getAllOnboardingSubscriptionAccess()` */
  static readonly GetAllOnboardingSubscriptionAccessPath = '/custom/onboarding/user/{userUid}/subscription';

  /**
   * Get all user access to subscriptions provided by the Onboarding Policy.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllOnboardingSubscriptionAccess()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOnboardingSubscriptionAccess$Response(params: GetAllOnboardingSubscriptionAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardingAccess>>> {
    return getAllOnboardingSubscriptionAccess(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all user access to subscriptions provided by the Onboarding Policy.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllOnboardingSubscriptionAccess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOnboardingSubscriptionAccess(params: GetAllOnboardingSubscriptionAccess$Params, context?: HttpContext): Observable<Array<OnboardingAccess>> {
    return this.getAllOnboardingSubscriptionAccess$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OnboardingAccess>>): Array<OnboardingAccess> => r.body)
    );
  }

  /** Path part for operation `grantSubscriptionAccessThroughOnboarding()` */
  static readonly GrantSubscriptionAccessThroughOnboardingPath = '/custom/onboarding/user/{userUid}/subscription/{subscriptionUid}';

  /**
   * Grant user access to a subscription through the Onboarding Policy.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `grantSubscriptionAccessThroughOnboarding()` instead.
   *
   * This method doesn't expect any request body.
   */
  grantSubscriptionAccessThroughOnboarding$Response(params: GrantSubscriptionAccessThroughOnboarding$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return grantSubscriptionAccessThroughOnboarding(this.http, this.rootUrl, params, context);
  }

  /**
   * Grant user access to a subscription through the Onboarding Policy.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `grantSubscriptionAccessThroughOnboarding$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  grantSubscriptionAccessThroughOnboarding(params: GrantSubscriptionAccessThroughOnboarding$Params, context?: HttpContext): Observable<void> {
    return this.grantSubscriptionAccessThroughOnboarding$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `revokeOnboardingSubscriptionAccess()` */
  static readonly RevokeOnboardingSubscriptionAccessPath = '/custom/onboarding/user/{userUid}/subscription/{subscriptionUid}/revoke';

  /**
   * Revoke user access to a subscription through the Onboarding Policy.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeOnboardingSubscriptionAccess()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeOnboardingSubscriptionAccess$Response(params: RevokeOnboardingSubscriptionAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return revokeOnboardingSubscriptionAccess(this.http, this.rootUrl, params, context);
  }

  /**
   * Revoke user access to a subscription through the Onboarding Policy.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revokeOnboardingSubscriptionAccess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeOnboardingSubscriptionAccess(params: RevokeOnboardingSubscriptionAccess$Params, context?: HttpContext): Observable<void> {
    return this.revokeOnboardingSubscriptionAccess$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `restoreOnboardingSubscriptionAccess()` */
  static readonly RestoreOnboardingSubscriptionAccessPath = '/custom/onboarding/user/{userUid}/subscription/{subscriptionUid}/restore';

  /**
   * Restore user access to a subscription through the Onboarding Policy.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restoreOnboardingSubscriptionAccess()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreOnboardingSubscriptionAccess$Response(params: RestoreOnboardingSubscriptionAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return restoreOnboardingSubscriptionAccess(this.http, this.rootUrl, params, context);
  }

  /**
   * Restore user access to a subscription through the Onboarding Policy.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restoreOnboardingSubscriptionAccess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreOnboardingSubscriptionAccess(params: RestoreOnboardingSubscriptionAccess$Params, context?: HttpContext): Observable<void> {
    return this.restoreOnboardingSubscriptionAccess$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllServiceOnboardedUsers()` */
  static readonly GetAllServiceOnboardedUsersPath = '/custom/onboarding/service/{serviceUid}/users';

  /**
   * Get all users who have access to this service through onboarding.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllServiceOnboardedUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllServiceOnboardedUsers$Response(params: GetAllServiceOnboardedUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardedUser>>> {
    return getAllServiceOnboardedUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all users who have access to this service through onboarding.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllServiceOnboardedUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllServiceOnboardedUsers(params: GetAllServiceOnboardedUsers$Params, context?: HttpContext): Observable<Array<OnboardedUser>> {
    return this.getAllServiceOnboardedUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OnboardedUser>>): Array<OnboardedUser> => r.body)
    );
  }

  /** Path part for operation `getAllOnboardingServiceAccess()` */
  static readonly GetAllOnboardingServiceAccessPath = '/custom/onboarding/user/{userUid}/service';

  /**
   * Get all user access to services provided by the Onboarding Policy.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllOnboardingServiceAccess()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOnboardingServiceAccess$Response(params: GetAllOnboardingServiceAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardingAccess>>> {
    return getAllOnboardingServiceAccess(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all user access to services provided by the Onboarding Policy.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllOnboardingServiceAccess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOnboardingServiceAccess(params: GetAllOnboardingServiceAccess$Params, context?: HttpContext): Observable<Array<OnboardingAccess>> {
    return this.getAllOnboardingServiceAccess$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OnboardingAccess>>): Array<OnboardingAccess> => r.body)
    );
  }

  /** Path part for operation `grantServiceAccessThroughOnboarding()` */
  static readonly GrantServiceAccessThroughOnboardingPath = '/custom/onboarding/user/{userUid}/service/{serviceUid}';

  /**
   * Grant user access to a service through the Onboarding Policy.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `grantServiceAccessThroughOnboarding()` instead.
   *
   * This method doesn't expect any request body.
   */
  grantServiceAccessThroughOnboarding$Response(params: GrantServiceAccessThroughOnboarding$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return grantServiceAccessThroughOnboarding(this.http, this.rootUrl, params, context);
  }

  /**
   * Grant user access to a service through the Onboarding Policy.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `grantServiceAccessThroughOnboarding$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  grantServiceAccessThroughOnboarding(params: GrantServiceAccessThroughOnboarding$Params, context?: HttpContext): Observable<void> {
    return this.grantServiceAccessThroughOnboarding$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `revokeOnboardingServiceAccess()` */
  static readonly RevokeOnboardingServiceAccessPath = '/custom/onboarding/user/{userUid}/service/{serviceUid}/revoke';

  /**
   * Revoke user access to a service through the Onboarding Policy.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeOnboardingServiceAccess()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeOnboardingServiceAccess$Response(params: RevokeOnboardingServiceAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return revokeOnboardingServiceAccess(this.http, this.rootUrl, params, context);
  }

  /**
   * Revoke user access to a service through the Onboarding Policy.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revokeOnboardingServiceAccess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeOnboardingServiceAccess(params: RevokeOnboardingServiceAccess$Params, context?: HttpContext): Observable<void> {
    return this.revokeOnboardingServiceAccess$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `restoreOnboardingServiceAccess()` */
  static readonly RestoreOnboardingServiceAccessPath = '/custom/onboarding/user/{userUid}/service/{serviceUid}/restore';

  /**
   * Restore user access to a service through the Onboarding Policy.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restoreOnboardingServiceAccess()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreOnboardingServiceAccess$Response(params: RestoreOnboardingServiceAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return restoreOnboardingServiceAccess(this.http, this.rootUrl, params, context);
  }

  /**
   * Restore user access to a service through the Onboarding Policy.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restoreOnboardingServiceAccess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreOnboardingServiceAccess(params: RestoreOnboardingServiceAccess$Params, context?: HttpContext): Observable<void> {
    return this.restoreOnboardingServiceAccess$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
